<template>
    <div id="foprovep" :class="alto_contenido">
         <!-- HEADER TITULO -->
        <div class="header-foprovep">
            <h1>
                <span class="negrita">FOPROVEP</span>
            </h1>
        </div>
        <!-- CONTENIDO PRINCIPAL -->
        <div class="container contenido_principal"> <!--el contenedor padre solo sirve para los estilos en ipad´s pro-->
            <!-- ===Apartado de las cards=== -->
                <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        alto_contenido(){ if(screen.width > 1366)  return 'pantalla_grande' }
    },
    methods:{
        validar_ruta(){

            const path = window.location.hostname=="localhost"? 
                'foprovep' :
                'haciendaChiapas/foprovep' /* ### ESTA CADENA PUEDE VARIAR A LA HORA DE IR A CALLE */
         
            if(window.location.pathname == `/${path}` || window.location.pathname == `/${path}/`){
                this.$router.push({name: 'menuQuienesSomos'});
            }
        }
    },
    created(){
        this.validar_ruta();
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style>
/* .pantalla_grande{  margin-bottom: 14rem !important; } */
#foprovep a:hover{
  color: #000 !important;
  text-decoration: none;
}


/* MENU QUIENES SOMOS */
#foprovep .title_document:hover{ box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important; }

#foprovep .title_document h5{
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 20px;
}


#foprovep a{
    text-decoration: none !important;
    color: #212529;
}
 
#foprovep a:hover{ color:#212529 !important; }
#foprovep .card-width{ width: 90%; }
    
    
/* SOMOS FOPROVEP */
@media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
}









/* MEDIA QUERY SOLO PARA IPAD 10 pro (MODO HORIZONTAL) */
@media only screen and 
(device-width : 1366px) and 
(device-height : 1024px) and 
(orientation : landscape) {
    #foprovep .contenido_principal{
        padding-top: 5rem; 
        padding-bottom: 5rem;
    }
} 
</style>